import { Injectable } from '@angular/core';
import { ICmsModelResource } from '../../../../core/resource/model/icms-model.resource';
import { NICmsCampaigns } from '../../icms-campaigns-interfaces';
import { ICmsCampaign } from './icms-campaign';

declare module '@df/catalog/resource' {
    interface IResources {
        campaign: ICmsCampaignResource;
    }
}

@Injectable({ providedIn: 'root' })
export class ICmsCampaignResource extends ICmsModelResource<ICmsCampaign, number> {
    static override instance = ICmsCampaign;
    readonly invalidatesUniversal = false;
    readonly invalidatesPrerender = false;

    /**
     * Publish campaign
     */
    async publish(campaign: ICmsCampaign): Promise<NICmsCampaigns.IPublishResponse> {
        const result = await this.requestService.send<NICmsCampaigns.IPublishResponse>(
            undefined,
            {
                path: 'cms/apply-campaign',
                data: {
                    id: campaign.id
                },
                api: 'node',
                token: true
            },
            undefined,
            err => {
                console.log('on error', err);
            }
        );

        return result;
    }
}
